//import webps

import imgSlider1 from 'assets/illustrations/tanulo_1.webp';
import imgSlider2 from 'assets/illustrations/tanulo_2.webp';
import imgSlider3 from 'assets/illustrations/tanulo_3.webp';
import imgSlider4 from 'assets/illustrations/tanulo_4.webp';
import imgSlider5 from 'assets/illustrations/tanulo_5.webp';
import imgSlider6 from 'assets/illustrations/tanulo_6.webp';
import imgSlider7 from 'assets/illustrations/tanulo_7.webp';

const people= [
{
    id: 1,
    image: imgSlider1,
    name: 'GPO autosiskola sikeres vizsga tanulo 1',

},
{
    id: 2,
    image: imgSlider2,
    name: 'GPO autosiskola sikeres vizsga tanulo 2',
},
{
    id: 3,
    image: imgSlider3,
    name: 'GPO autosiskola sikeres vizsga tanulo 3',
},
{
    id: 4,
    image: imgSlider4,
    name: 'GPO autosiskola sikeres vizsga tanulo 4',

},
{
    id: 5,
    image: imgSlider5,
    name: 'GPO autosiskola sikeres vizsga tanulo 5',
},
{
    id: 6,
    image: imgSlider6,
    name: 'GPO autosiskola sikeres vizsga tanulo 6',
},
{
    id: 7,
    image: imgSlider7,
    name: 'GPO autosiskola sikeres vizsga tanulo 7',
}
]
export default people